import api from './index';

const getProductTypes = (params) => api.raw.get('/products/product_types/', { params });
const getProductType = (id) => api.raw.get(`/products/product_types/${id}/`);
const createProductType = (data) => api.raw.post('/products/product_types/', data, { isAuth: true })
const deleteProductType = (id) => api.raw.delete(`/products/product_types/${id}/`, { isAuth: true });
const updateProductType = (id, data) => api.raw.put(`/products/product_types/${id}/`, data, { isAuth: true });
const getProducts = (params) => api.raw.get('/products/', { params });
const getProduct = (id) => api.raw.get(`/products/${id}/`);
const createProduct = (data) => api.raw.post('/products/', data, { isAuth: true });
const saveProductInfos = (data) => api.raw.post('/products/save_product/', data, { isAuth: true });
const updateProductInfos = (id, data) => api.raw.post(`/products/${id}/update_product/`, data, { isAuth: true });
const updateProduct = (id, data) => api.raw.put(`/products/${id}/`, data, { isAuth: true });
const deleteProduct = (id) => api.raw.delete(`/products/${id}/`, { isAuth: true });
const getProductOthers = (params) => api.raw.get(`/products/product_others/`, { params });
const getProductOther = (id) => api.raw.get(`/products/product_others/${id}/`);
const createProductOther = (data) => api.raw.post('/products/product_others/', data, { isAuth: true });
const updateProductOther = (id, data) => api.raw.put(`/products/product_others/${id}/`, data, { isAuth: true });
const deleteProductOther = (id) => api.raw.delete(`/products/product_others/${id}/`, { isAuth: true });
const getProductTypes2 = (params) => api.raw.get('/products/product_types2/', { params });
const getProductType2 = (id) => api.raw.get(`/products/product_types2/${id}/`);
const createProductType2 = (data) => api.raw.post('/products/product_types2/', data, { isAuth: true });
const deleteProductType2 = (id) => api.raw.delete(`/products/product_types2/${id}/`, { isAuth: true });
const updateProductType2 = (id, data) => api.raw.put(`/products/product_types2/${id}/`, data, { isAuth: true });
const getProductTypes2Others = (params) => api.raw.get('/products/product_types2_others/', { params });
const getProductType2Other = (id) => api.raw.get(`/products/product_types2_others/${id}/`);
const createProductType2Other = (data) => api.raw.post('/products/product_types2_others/', data, { isAuth: true });
const updateProductType2Other = (id, data) => api.raw.put(`/products/product_types2_others/${id}/`, data, { isAuth: true });
const deleteProductType2Other = (id) => api.raw.delete(`/products/product_types2_others/${id}/`, { isAuth: true });

export default {
    getProducts,
    getProduct,
    createProduct,
    saveProductInfos,
    updateProductInfos,
    updateProduct,
    deleteProduct,
    updateProductType,
    getProductTypes,
    getProductType,
    deleteProductType,
    createProductType,
    getProductOthers,
    getProductOther,
    createProductOther,
    updateProductOther,
    deleteProductOther,
    getProductTypes2,
    getProductType2,
    deleteProductType2,
    createProductType2,
    updateProductType2,
    getProductTypes2Others,
    getProductType2Other,
    deleteProductType2Other,
    createProductType2Other,
    updateProductType2Other
};